import {
  BiGroup,
  HiOutlineAdjustments,
  HiOutlineClipboardList,
  HiOutlineCollection,
  HiOutlineCube,
  HiOutlineDatabase,
  HiOutlineDeviceMobile,
  HiOutlineDocumentReport,
  HiOutlineFlag,
  HiOutlineLibrary,
  HiOutlineMap,
  HiOutlineNewspaper,
  HiOutlineShieldCheck,
  HiOutlineTruck,
  HiOutlineViewGrid,
  FaUsers 
} from "react-icons/all";

export const MenuConstants = [
  {
    name: "Dashboard",
    item: [
      {
        id: "dashboard",
        name: "National Data",
        path: "/national-data",
        icon: <HiOutlineDatabase />,
      },
      {
        id: "dashboard",
        name: "International Data",
        path: "/international-data",
        icon: <HiOutlineDatabase />,
      },
      {
        id: "dashboard",
        name: "International Online",
        path: "/international-data-online",
        icon: <HiOutlineDatabase />,
      },
    ],
  },
  {
    name: "Form Data",
    item: [
      {
        id: "ticket-sales",
        name: "Ticket Sales",
        path: "/form-data/ticket-sale",
        icon: <HiOutlineViewGrid />,
      },
      {
        id: "tourist-by-nationalities",
        name: "Tourist By Nationalities",
        path: "/form-data/tourist-by-nationality",
        icon: <HiOutlineViewGrid />,
      },
      {
        id: "tourist-by-tour-agent-or-fit",
        name: "Tourist By Tour Agent",
        path: "/form-data/tourist-by-tour-agent",
        icon: <HiOutlineViewGrid />,
      },
      {
        id: "tourist-at-each-temple",
        name: "Tourist at Each Temple",
        path: "/form-data/tourist-at-each-temple",
        icon: <HiOutlineViewGrid />,
      },
    ],
  },
  {
    name: "Temple",
    item: [
      {
        id: "temple",
        name: "Temple",
        path: "/temple",
        icon: <HiOutlineLibrary />,
      },
      {
        id: "temple-group",
        name: "Temple Group",
        path: "/temple-group",
        icon: <HiOutlineLibrary />,
      },
    ],
  },
  {
    name: "More than Temple",
    item: [
      {
        id: "annual-event",
        name: "Annual Event",
        path: "/annual-event",
        icon: <HiOutlineViewGrid />,
      },
      {
        id: "museum",
        name: "Museum",
        path: "/museum",
        icon: <HiOutlineViewGrid />,
      },
      {
        id: "community",
        name: "Community",
        path: "/community",
        icon: <HiOutlineViewGrid />,
      },
      {
        id: "activities",
        name: "Activities",
        path: "/activities",
        icon: <HiOutlineViewGrid />,
      },
    ],
  },
  {
    name: "Code Of Conduct",
    item: [
      {
        id: "code-of-conduct",
        name: "Code of Conduct",
        path: "/code-of-conduct",
        icon: <HiOutlineClipboardList />,
      },
    ],
  },
  {
    name: "Others",
    item: [
      {
        id: "feed",
        name: "Feed",
        path: "/feed",
        icon: <HiOutlineNewspaper />,
      },
      {
        id: "slide",
        name: "Slide",
        path: "/slide",
        icon: <HiOutlineCollection />,
      },
      {
        id: "icon",
        name: "Icon",
        path: "/icon",
        icon: <HiOutlineCube />,
      },
      {
        id: "zone",
        name: "Zone",
        path: "/zone",
        icon: <HiOutlineMap />,
      },
    ],
  },
  {
    name: "Report",
    item: [
      {
        id: "report",
        name: "Ticket Sales",
        path: "/report/ticket-sale",
        icon: <HiOutlineDocumentReport />,
      },
      {
        id: "report",
        name: "Tourist By Nationalities",
        path: "/report/tourist-by-nationality",
        icon: <HiOutlineDocumentReport />,
      },
      {
        id: "report",
        name: "Tourist By Tour Agent",
        path: "/report/tourist-by-tour-agent",
        icon: <HiOutlineDocumentReport />,
      },
      {
        id: "report",
        name: "Tourist at Each Temple",
        path: "/report/tourist-each-temple",
        icon: <HiOutlineDocumentReport />,
      },
      {
        id: "report",
        name: "Profile National Visitor",
        path: "/visitor",
        icon: <HiOutlineDocumentReport />,
      },
      {
        id: "purpose-of-visit",
        name: "Purpose of Visit",
        path: "/report/purpose-of-visit",
        icon: <HiOutlineDocumentReport />,
      },
      {
        id: "transportation",
        name: "Transportation",
        path: "/report/transportation",
        icon: <HiOutlineTruck />,
      },
      {
        id: "report",
        name: "Feedback",
        path: "/feedback",
        icon: <HiOutlineDocumentReport />,
      },
    ],
  },
  {
    name: "Setting",
    item: [
      {
        id: "privacy-and-terms",
        name: "Privacy & Terms",
        path: "/privacy",
        icon: <HiOutlineShieldCheck />,
      },
      {
        id: "delete-user-request",
        name: "User Request",
        path: "/user-delete-request",
        icon: <FaUsers  />,
      },
      {
        id: "nationality",
        name: "Nationality",
        path: "/nationality",
        icon: <HiOutlineFlag />,
      },
      {
        id: "contact",
        name: "Contact",
        path: "/contact",
        icon: <HiOutlineDeviceMobile />,
      },
      {
        id: "system-roles",
        name: "System Roles",
        path: "/system-role",
        icon: <HiOutlineAdjustments />,
      },
      {
        id: "users",
        name: "User",
        path: "/user",
        icon: <BiGroup />,
      },
    ],
  },
];
